<template>
  <div>
    <ResetAccount />
  </div>
</template>

<script>
import ResetAccount from "../components/ResetAccount/ResetAccount.vue";

export default {
  components: { ResetAccount },
};
</script>
